// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t2-5";
export var filledCircle = "_t2-4";
export var historyEntry = "_t2-3";
export var messageSideLeft = "_t2-1";
export var messageSideRight = "_t2-2";
export var orderTrackingCarouselWrapper = "_t2-6";
export var orderTrackingInfoContainer = "_t2-0";